import { FlowHead } from '@/shared/ui/Seo/FlowHead'
import { AppLayout } from '@/shared/ui/layouts/AppLayout/index'
import { CoverLayout } from '@/shared/ui/layouts/CoverLayout/index'
import type { ReactNode } from 'react'
import { useContactState } from '../state'

type ContatoLayoutProps = {
  children: ReactNode
  variant?: 'app' | 'cover'
  title?: string
  description?: string
}

const defaultTitle = 'Fale conosco | Flash'
const defaultDescription =
  'Precisa de suporte com os produtos Flash? Preencha nosso formulário de atendimento e receba ajuda especializada do nosso time.'

export function ContatoLayout({
  children,
  variant = 'app',
  title,
  description,
}: ContatoLayoutProps) {
  const { currentStep } = useContactState()

  return (
    <>
      <FlowHead
        title={title ?? defaultTitle}
        description={description ?? defaultDescription}
      />
      {variant === 'cover' ? (
        <CoverLayout>{children}</CoverLayout>
      ) : (
        <AppLayout
          steps={['Identificação', 'Motivo de contato', 'Mensagem']}
          currentStep={currentStep}
        >
          {children}
        </AppLayout>
      )}
    </>
  )
}
